import { supabase } from './mockData';

export interface Clinic {
  id: string;
  name: string;
  phone?: string;
  email?: string;
  address?: string;
  hours?: string;
  logo_url?: string;
}

export async function getClinic(clinicId: string): Promise<Clinic | null> {
  const { data, error } = await supabase
    .from('clinics')
    .select('*')
    .eq('id', clinicId)
    .maybeSingle();
  if (error) {
    console.error('getClinic:', error.message);
    return null;
  }
  return data as Clinic | null;
}

export async function updateClinic(clinicId: string, updates: Partial<Clinic>): Promise<Clinic | null> {
  const payload: any = {};
  if (updates.name !== undefined) payload.name = updates.name;
  if (updates.phone !== undefined) payload.phone = updates.phone;
  if (updates.email !== undefined) payload.email = updates.email;
  if (updates.address !== undefined) payload.address = updates.address;
  if (updates.hours !== undefined) payload.hours = updates.hours;
  if (updates.logo_url !== undefined) payload.logo_url = updates.logo_url;

  const { data, error } = await supabase
    .from('clinics')
    .update(payload)
    .eq('id', clinicId)
    .select()
    .single();
  if (error) {
    console.error('updateClinic:', error.message);
    throw new Error(error.message);
  }
  return data as Clinic;
}
